/**
 * 新做法
 * @auth xuyd
 * @date 2024-05-02
 */

import Vue from 'vue';
import WbWidgetDefine from './wb-widget-define'
import WbWidgetProps from './wb-widget-props'
import WbWidgetWorkbench from './wb-widget-workbench'

/**
 * 工作台处理类
 * @param opts
 * @constructor
 */
function Workbench_(opts) {
  let widgetMenuList = [];
  let widgetTemplateMenu = [];
  let widgetTemplateMap = [];

  let widgetViewList = [];

  let draggingWidgetName = null; // 拖动的组件名
  let draggingWidgetOffsetX = null; // 拖动的组件偏移x
  let draggingWidgetOffsetY = null; // 拖动的组件偏移y

  let selectedWidget = null;// 选择的组件对象
  let scale = 0.6;// 缩放比例
  let defineComp = null;
  let propsComp = null;
  let workbenchComp = null;

  draggingWidgetOffsetX = opts.draggingWidgetOffsetX || 0;
  draggingWidgetOffsetY = opts.draggingWidgetOffsetY || 0;
  selectedWidget = opts.selectedWidget;
  if(opts.scale) {
    scale = opts.scale;
  }

  // 添加组件
  if(opts.defineContainerId) {
    let childVue = Vue.extend(WbWidgetDefine);
    defineComp = new childVue();
    defineComp.$mount("#" + opts.defineContainerId);
  }
  if(opts.propsContainerId) {
    let childVue = Vue.extend(WbWidgetProps);
    propsComp = new childVue();
    propsComp.$mount("#" + opts.propsContainerId);
  }
  if(opts.workbenchContainerId) {
    let childVue = Vue.extend(WbWidgetWorkbench);
    workbenchComp = new childVue();
    workbenchComp.$mount("#" + opts.workbenchContainerId);
  }

  let register = (components) =>{
    workbenchComp.components('widgetTime', components[1]);
  }
}

/**
 * 构造工作台实例
 *
 * @param defineContainerId
 * @param propsContainerId
 * @param workbenchContainerId
 * @returns {Workbench_}
 */
export function initWorkbench(defineContainerId,propsContainerId,workbenchContainerId) {
  return new Workbench_({
    defineContainerId: defineContainerId,
    propsContainerId: propsContainerId,
    // workbenchContainerId: workbenchContainerId,
  })
}

/**
 * 注册组件
 *
 * @param workbench
 * @param components
 */
export function registerComponents(workbench, components) {
  workbench.register(components);
}
